<template>
    <Head :title="'St. Johns County Crime Map Resources'" >
        <link rel="canonical" href="https://www.ginabetbeze.com/crime-maps" />
        <meta name="description" content="Find information on Crime in Northeast Florida." />
    </Head>
    <!-- Simple Blurb -->

    <PageContent
        :id="'crime-maps-page'"
        :breadcrumbs="['Home','Resources','Crime Maps']"
        :header="'Crime Maps'"
    >
        <BasicContainer>
            <SecondaryHeader>Crime Maps for Jacksonville</SecondaryHeader>
            <Paragraph>
                Stay informed about crime in your neighborhood with these interactive crime maps. Most of these sites
                collect data from local police departments and other sources to provide up-to-date information about
                crime.
            </Paragraph>
            <InfoAlert>
                I cannot provide any guarantees about the accuracy of the information on these sites, but they can be a
                useful tool for understanding crime trends in your area.
            </InfoAlert>
            <List>
                <a href="https://www.adt.com/crime" target="_blank" rel="noreferrer">
                    ADT Crime Map
                    <ArrowTopRightOnSquareIcon class="hidden tablet-sm:inline-block h-5 w-5 mr-2 mb-1" aria-hidden="true" />
                </a>
                <a href="https://www.crimemapping.com/map/fl/jacksonville" target="_blank" rel="noreferrer">
                    CrimeMapping.com
                    <ArrowTopRightOnSquareIcon class="hidden tablet-sm:inline-block h-5 w-5 mr-2 mb-1"
                                               aria-hidden="true" />
                </a>
            </List>
        </BasicContainer>
    </PageContent>
</template>
<script setup>
import PageContent from "../Components/Layout/PageContent.vue";
import HomeLayout from "../Layouts/HomeLayout.vue";
import { Head, Link, useForm, usePage } from "@inertiajs/vue3";
import Breadcrumbs from "@/Components/PageContent/Breadcrumbs.vue";
import BasicContainer from "@/Components/PageContent/Containers/BasicContainer.vue";
import MainHead from "@/Components/PageContent/MainHead.vue";
import Paragraph from "@/Components/PageContent/Paragraph.vue";
import SecondaryHeader from "@/Components/PageContent/SecondaryHeader.vue";
import List from "@/Components/PageContent/List.vue";
import InfoAlert from "@/Components/PageContent/InfoAlert.vue";
import { ArrowTopRightOnSquareIcon } from "@heroicons/vue/24/outline";

defineOptions({ layout: HomeLayout });
const page = usePage();
const props = defineProps({
    title: {
        type: String,
        required: true,
    },
});
</script>
